export default __webpack_public_path__ + "static/media/pointUsageIcon.6dda78e9.svg";